import React from "react";
import PropTypes from "prop-types";

class AddFishForm extends React.Component {

    nameRef = React.createRef();
    priceRef = React.createRef();
    statusRef = React.createRef();
    descRef = React.createRef();
    imageRef = React.createRef();

    static propTypes = {
        addFish: PropTypes.func
    };

    // this is shorthand for a function with event as the argument
    createFish = (event) => {
        // 1. Stop the form from submitting
        event.preventDefault();
        // 2. create the fish object  ...this fish needs to get into state
        const fish = {
            name: this.nameRef.value.value,
            price: parseFloat(this.priceRef.value.value),  // this stores as number not string
            status: this.statusRef.value.value,
            desc: this.descRef.value.value,
            image: this.imageRef.value.value,
        };
        // for testing output to console
        // console.log(this.nameRef.value.value);
        // or the entire fish object
        // console.log(fish);
        this.props.addFish(fish);
        // 3. refresh the form
        event.currentTarget.reset();
    };

    render() {
        return (
            // submit calls createFish, see above
            // refs are how to get values out which get used in above
            <form className="fish-edit" onSubmit={this.createFish}>
                <input name="name" ref={this.nameRef} type="text" placeholder="Name" />
                <input name="price" ref={this.priceRef} type="text" placeholder="Price" />
                <select name="status" ref={this.statusRef} >
                    <option value="available">Fresh</option>
                    <option value="unavailable">Sold Out!</option>
                </select>
                <textarea name="desc" ref={this.descRef} placeholder="Desc" />
                <input name="image" ref={this.imageRef}type="text" placeholder="Image" />
                <button type="submit">+ Add Fish</button>
            </form>
        )
    }
}

export default AddFishForm;


// WEBPACK FOOTER //
// ./src/components/AddFishForm.js